import { render, staticRenderFns } from "./Mala.vue?vue&type=template&id=96a29b22"
import script from "./Mala.vue?vue&type=script&lang=js"
export * from "./Mala.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports